import { FunctionComponent, SyntheticEvent, useCallback } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { SteamItemImage } from '../item';
import playAudio from '~frontend/utils/playAudio';
import { useItemsLeft, useUpgradeAmount, useIdsItemsLeft } from './hooks';
import { useConfig } from '~components/hooks';

import { Price } from '~ui/Price';
import Currency from '../Currency';

const MoreItems: FunctionComponent = () => {
  const { t } = useTranslation();
  const getConfig = useConfig();

  const [itemsLeft, setItemsLeft] = useItemsLeft();
  const [upgradeAmount, setUpgradeAmount] = useUpgradeAmount();
  const [idsItemsLeft, setIdsItemsLeft] = useIdsItemsLeft();

  const getGames = _.slice(itemsLeft, 0, 7);

  const removeItemFromUpgrade = useCallback(
    (event: SyntheticEvent<HTMLElement>) => {
      event.preventDefault();

      const gameId = Number(event.currentTarget.dataset.id);

      const getGame = _.clone(_.find(itemsLeft, ['id', gameId]));

      setIdsItemsLeft(_.filter(idsItemsLeft, getItem => getItem !== gameId));
      setItemsLeft(_.filter(itemsLeft, getItem => getItem.id !== gameId));

      setUpgradeAmount(upgradeAmount - getGame.price);
      playAudio(null, '14.mp3', 0.4);
    },
    [
      setIdsItemsLeft,
      itemsLeft,
      idsItemsLeft,
      setIdsItemsLeft,
      setItemsLeft,
      setUpgradeAmount,
    ],
  );

  if (_.size(getGames) === 0) {
    return null;
  }

  return (
    <div className="more-items">
      <div className="title">
        <span>
          {_.size(itemsLeft)}
          {'x'}
        </span>
        <div className="cost">
          {getConfig.isEU ? (
            <>
              <Currency />
              <Price sum={upgradeAmount} />
            </>
          ) : (
            <>
              <Price sum={upgradeAmount} />
              <Currency />
            </>
          )}
        </div>
      </div>
      <div className={`items ${_.size(getGames) < 4 && 'single-col'}`}>
        {getGames.map(getGame => (
          <div
            className="top-drop-item"
            data-rar={getGame.getItem.color}
            key={getGame.id}
            data-id={getGame.id}
            onClick={removeItemFromUpgrade}
          >
            <div className="honey"></div>
            <div
              className="drop-img"
              style={{ backgroundImage: `url(${getGame.getItem.getImage})` }}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MoreItems;
